/** Public project sessions are independent of staff JWTs and never redirect to staff sign-in. */
export class HomeownerApiError extends Error {
  readonly status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}
export async function homeownerRequest<T>(
  token: string,
  session: string | null,
  path = "",
  method = "GET",
  body?: unknown,
): Promise<T> {
  const response = await fetch(
    `/api/homeowner/${encodeURIComponent(token)}/${path}`,
    {
      method,
      credentials: "omit",
      cache: "no-store",
      headers: {
        ...(session ? { "X-Homeowner-Session": session } : {}),
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    },
  );
  if (!response.ok) {
    let message = "We could not complete that request. Please try again.";
    try {
      const data = await response.json();
      message = data.detail || Object.values(data).flat().join(" ");
    } catch {
      /* retain readable fallback */
    }
    throw new HomeownerApiError(response.status, message);
  }
  return response.status === 204 ? (undefined as T) : response.json();
}
export async function homeownerFile(
  token: string,
  session: string,
  path: string,
): Promise<Blob> {
  if (!/^files\/\d+\/$/.test(path)) throw new Error("Invalid project file.");
  const response = await fetch(
    `/api/homeowner/${encodeURIComponent(token)}/${path}`,
    {
      credentials: "omit",
      cache: "no-store",
      headers: { "X-Homeowner-Session": session },
    },
  );
  if (!response.ok)
    throw new HomeownerApiError(
      response.status,
      "This shared document is no longer available.",
    );
  return response.blob();
}
